// extracted by mini-css-extract-plugin
export default {"booksmain":"Books_booksmain__5A-KI"};